import { css } from '@conexasaude/hero'
import { SerializedStyles } from '@emotion/utils'

export const cardMixin = (): SerializedStyles => {
  return css`
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
  `
}

export default cardMixin
